package com.cs.ejobin.model

data class Skill(
    val id: String,
    val label: String
)